import { render } from "./Menu.vue?vue&type=template&id=6660585b&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=6660585b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6660585b"

export default script